import { AreaChart } from './AreaChart';
import { BarChart } from './BarChart';
import { BubbleChart } from './BubbleChart';
import { CigaretteChart } from './CigaretteChart';
import { CompactHorizontalBarChart } from './CompactHorizontalBarChart';
import { DonutChart } from './DonutChart';
import { HistogramChart } from './HistogramChart';
import { LineChart } from './LineChart';
import { RadarChart } from './RadarChart';
import { ScatterPlotChart } from './ScatterPlotChart';
import { VennChart } from './VennChart';

export default {
  Line: LineChart,
  Bar: BarChart,
  Histogram: HistogramChart,
  ScatterPlot: ScatterPlotChart,
  Area: AreaChart,
  Bubble: BubbleChart,
  Donut: DonutChart,
  Venn: VennChart,
  Radar: RadarChart,
  Cigarette: CigaretteChart,
  CompactHorizontalBar: CompactHorizontalBarChart,
};
